import { Package, ShoppingCart } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardFooter } from "./ui/card";
import { Badge } from "./ui/badge";
import { CatalogItem, CatalogItemListReq, PropertyFilter } from '../types/catalog'; 
import { ImageWithFallback } from "./figma/ImageWithFallback";
interface Product {
  id: string;
  name: string;
  category: string;
  price: number;
  description: string;
  stock: number;
  image: string;
}

interface ProductCardProps {
  product: CatalogItem;
  onAddToCart: (product: CatalogItem,storage: string,price:number) => void;
  onViewDetails: (product: CatalogItem) => void;
}

export function ProductCard({ product, onAddToCart, onViewDetails }: ProductCardProps) {
   const kv: Record<string, string> = Object.fromEntries(
    (product.props?.prop ?? []).map(p => [p.code, p.value])
  );
  const analog = kv['analog'] || '';
  const width = kv['width'] || '';
  const category = kv['category'] ;
  const model = kv['model'] || '';
  const pic='https://cdn.yutongoriginal.ru/product_images/'+product.code+'.jpg';
  return (
    <Card className="overflow-hidden hover:shadow-lg transition-shadow cursor-pointer border-blue-100">
      <div >
        <div className="overflow-hidden">
   
             <ImageWithFallback
                      src={pic}
                      alt={product.name}
                      className="object-cover hover:scale-105 transition-transform catalog_img"
                    />
        </div>
        <CardContent className="p-4" onClick={() => onViewDetails(product)}>
          <Badge className="mb-2 bg-blue-100 text-blue-700 hover:bg-blue-200">
            {category}
          </Badge>
          <h3 className="font-semibold text-lg mb-1 line-clamp-1">{product.name}</h3>
          <p className="text-sm text-gray-600 line-clamp-2 mb-2"><b>Артикул: </b>{product.code}</p>
          {analog}
          <ul>

          </ul>
          <div className="flex items-center justify-between">
            <span className="text-2xl font-bold text-blue-600">{product.price.toFixed(2)}₽</span>
            <span className="text-sm text-gray-500">
              {product.qty > 0 ? `${product.qty} in stock` : 'Под заказ'}
            </span>
          </div>
        </CardContent>
      </div>
      <CardFooter className="p-4 pt-0">
                                {product.storage?.map(stock => (   
          <div className="flex items-center justify-between gap-4 pt-3 border-t border-gray-200">
            <div className="flex items-center gap-2 text-sm">
             <span>Склад {stock.storage}</span>  <Package className="h-4 w-4 text-gray-500" />
              <span className={stock.qty > 0 ? "text-green-600 font-medium" : "text-red-600 font-medium"}>
                {stock.qty > 0 ? `${stock.qty}` : 'под заказ'}
              </span>
            </div>
            <div className="flex items-center">
            <div className="text-xl font-bold text-blue-600 pr-3">{stock.price.toFixed(2)}₽</div>
            <Button 
              className="bg-blue-600 hover:bg-blue-700"
              onClick={(e) => {
                e.stopPropagation();
                onAddToCart(product,stock.storage,stock.price);
              }}
              disabled={stock.qty === 0}
            >
              <div className="text-right flex-shrink-0">
                
              </div>
              <ShoppingCart className="mr-2 h-4 w-4" />
              В корзину
            </Button>
          </div></div>
 ))}
      </CardFooter>
    </Card>
  );
}
